export const EXTEND_CERTIFIED_LABEL: { [key: string]: string } = {
	is_certified: "Ist BAK-zertifiziert",
};
